// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  height: 70vh;
  display: flex;
  padding-left: 1.5em;
  padding-right: 1.5em;
  justify-content: center;
  align-items: center;
}
.container .form-header .title {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
}
.container .timer-form {
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  background: var(--ion-color-secondary);
}
.container .timer-form .description {
  text-align: center;
  margin-bottom: 10px;
}
.container .timer-form .form-row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.container .timer-form ion-input {
  height: auto;
  max-width: 56px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  --padding-start: 0;
  border-radius: 10px;
  margin-right: 20px;
  border: 1px solid var(--ion-color-primary);
}

:host ::ng-deep app-circular-progress .progress-container {
  width: 300px;
  height: 300px;
}

.form-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.form-header ion-icon {
  font-size: 2rem;
}

.timer-container {
  padding: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 100%;
}

.timer-display {
  font-size: 4em;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/amrap-timer/amrap-timer.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;AACR;AAEI;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,sCAAA;AAAR;AAEQ;EACI,kBAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;AAFZ;;AAQI;EACI,YAAA;EACA,aAAA;AALR;;AASA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AANJ;AAQI;EACI,eAAA;AANR;;AAUA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AAPJ;;AAUA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,+BAAA;AAPJ","sourcesContent":[".container {\n    height: 70vh;\n    display: flex;\n    padding-left: 1.5em;\n    padding-right: 1.5em;\n    justify-content: center;\n    align-items: center;\n\n    .form-header .title {\n        text-align: center;\n        font-size: 2rem;\n        font-weight: bold;\n    }\n\n    .timer-form {\n        height: 100%;\n        display: flex;\n        width: 100%;\n        flex-direction: column;\n        justify-content: space-around;\n        background: var(--ion-color-secondary);\n\n        .description {\n            text-align: center;\n            margin-bottom: 10px;\n        }\n\n        .form-row {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n\n        ion-input {\n            height: auto;\n            max-width: 56px;\n            text-align: center;\n            font-size: 1.5rem;\n            font-weight: bold;\n            --padding-start: 0;\n            border-radius: 10px;\n            margin-right: 20px;\n            border: 1px solid var(--ion-color-primary);\n        }\n    }\n}\n\n:host ::ng-deep {\n    app-circular-progress .progress-container {\n        width: 300px;\n        height: 300px;\n    }\n}\n\n.form-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n\n    ion-icon {\n        font-size: 2rem;\n    }\n}\n\n.timer-container {\n    padding: 1em;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: center;\n    height: 100%;\n}\n\n.timer-display {\n    font-size: 4em;\n    text-align: center;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
